<template>
    <default-modal
        :show="showModal"
        :closeOnClickModal="false"
        :height="0"
        @close="closeModal"
    >

        <el-form :model="form" :rules="rules" ref="form">
            <div class="gcmcn-inputs-container">
                <div class="flex-basis-10">
                    <el-form-item class="gcmcn-form-input" prop="contact">
                        <div class="gcmcn-form-label">Contact</div>
                        <el-input v-model="form.contact" size="mini"></el-input>
                    </el-form-item>

                </div>
            </div>
            <div class="gcmcn-inputs-container">
                <div class="flex-basis-5">
                    <el-form-item class="gcmcn-form-input" prop="contact">
                        <div class="gcmcn-form-label">Subjects to receive</div>
                        <el-switch
                            v-model="form.all_subjects"
                            active-text="All"
                            inactive-text="Some"
                            :active-value="true"
                            :inactive-value="false"
                            size="mini"
                        ></el-switch>
                    </el-form-item>
                </div>
                <div v-if="!form.all_subjects" class="flex-basis-5">
                    <el-form-item class="gcmcn-form-input" prop="subjects_uid">
                        <div class="gcmcn-form-label">Subjects</div>
                        <el-select
                            v-model="form.subjects_uid"
                            placeholder="Select"
                            popper-class="gcmcn-popper"
                            multiple
                            size="mini"
                            style="width: 100%;"
                        >
                            <el-option
                                v-for="item in $store.getters.adminNotifSubjects"
                                :key="item.uid"
                                :label="item.name"
                                :value="item.uid">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </div>
            </div>
            <div class="gcmcn-inputs-container">
                <div class="flex-basis-10">
                    <div class="gcmcn-form-label">Availability</div>
                    <el-form-item class="gcmcn-form-input" prop="availability">
                        <el-checkbox-group
                            v-model="form.availability"
                            :min="1"
                        >
                            <el-checkbox label="active_day">day</el-checkbox>
                            <el-checkbox label="active_night">night</el-checkbox>
                            <el-checkbox label="active_weekend">weekend</el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                </div>
            </div>
            <div class="gcmcn-inputs-container">
                <div class="flex-basis-10">
                    <el-form-item class="gcmcn-form-input" prop="active">
                        <div class="gcmcn-form-label">Active</div>
                        <el-switch
                            v-model="form.active"
                            active-text="Yes"
                            inactive-text="No"
                            :active-value="true"
                            :inactive-value="false"
                        ></el-switch>
                    </el-form-item>
                </div>
            </div>

        </el-form>
        <div class="modal-action-button-container">
            <el-button
                class="delete-event-cancel-btn"
                type="text"
                small
                :loading="loading"
                @click="closeModal"
            >Cancel</el-button>
            <el-button
                class="gcmcn-primary-btn small validate-btn delete-event-confirm-btn"
                :loading="loading"
                @click="create"
            >Validate</el-button>
        </div>
    </default-modal>
</template>

<script>

import DefaultModal from 'gcmcn-common/src/components/gcmcn-modal-theme.vue';
export default {

    components: {
        DefaultModal,
    },

    props: {

    },

    data (){
        const checkContact  = (rule, value, callback) => {
            let regexPhone = /^(\+33|\+33)[6-7][0-9]{8}$/;
            let matchPhone = value.match(regexPhone);
            let regexEmail = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
            let matchEmail = value.match(regexEmail);
            if(value === '') {
                callback(new Error('Contact email or phone number is required'));
            } else if(value.match(/[a-z]/i)) {
                if(!matchEmail) {
                    callback(new Error('Valid email is required'));
                }
            } else if (!matchPhone){
                callback(new Error('Number should start with +336 or +337'));
            }
            callback();
        };
        return {
            showModal: false,
            loading: false,
            form: {
                contact: '',
                all_subjects: true,
                subjects_uid: [],
                availability: [],
                active: true,
            },
            rules: {
                contact: [{required: true, validator: checkContact,}],
                all_subjects: [{required: true,}],
                subjects_uid: [{required: true,type: 'array',message: 'Choose at least one option',}],
                availability: [{required: true, message: 'Choose at least one option',}],
                active: [{required: true,}],
            },
        };
    },

    computed: {

    },

    mounted (){

    },

    methods: {
        open (){
            this.showModal = true;
        },
        closeModal (){
            this.showModal = false;
            this.$set(this, 'form', {
                name: '',
                contact: '',
                all_subjects: true,
                subjects_uid: [],
                availability: [],
                active: true,
            });
            this.loading = false;
        },

        create() {
            this.$refs.form.validate((valid) => {
                if(valid){
                    this.loading = true;
                    let item = {
                        name: this.form.name,
                        contact: this.form.contact,
                        all_subjects: this.form.all_subjects, // Boolean, if true the user is notified with all subjects
                        subjects_uid: this.form.subjects_uid, // M2M, the user will only be notified by selected subjects
                        active: this.form.active,
                        active_day: this.form.availability.includes('active_day'),
                        active_night: this.form.availability.includes('active_night'),
                        active_weekend: this.form.availability.includes('active_weekend'),
                    };

                    return this.$store.dispatch('createItem', {
                        item: item,
                        model: 'adminNotifConfigs',
                        url: this.$store.state.api.meta.listModels.adminNotifConfigs.url,
                        scopes: this.$store.state.api.scopes || {},
                    }).then((res) => {
                        this.$message({
                            type: 'success',
                            message: `The admin configuration ${res.name} has been created.`
                        });
                        this.$emit('admin-notif-created');
                        this.closeModal();
                    }).catch((e) => {
                        console.error(e);
                        this.$message({
                            type: 'error',
                            message: `There has been an error during the creation. Please retry or contact an administrator.`
                        });
                    });
                }
            });
        },
    },
};
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/page/ManageAlarmAlertNotification/modal-create-admin-notif.vue